<template>
    <div class="listings-list layout6">
        <Swiper v-bind="swiperOption">
            <Slide v-for="(item, index) in result.listings" :key="index">
                <house :house="item" />
            </Slide>
            <template v-if="showPlaceholder">
                <Slide
                    v-for="i in len"
                    class="house-placeholder"
                    :key="i"
                >
                    <li class="house-slider-item layout6">
                        <article>
                            <div class="house-imgs">
                                <site-img :src="picSrc" dir="64" />
                            </div>
                            <div class="house-info">
                                <div class="house-price-wrap"></div>
                                <div class="detail"></div>
                                <div class="address"></div>
                                <div class="mls-box"></div>
                            </div>
                        </article>
                    </li>
                </Slide>
            </template>
        </Swiper>
    </div>
</template>
<script>
import house from './house.vue';
import list from '../list.js';
// import util from '@/common/util';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';

export default {
    computed: {
        swiperOption({ isMobile }) {
            const navigation = {
                closest: '.md-house.layout6',
                nextEl: '.house-next.layout6',
                prevEl: '.house-prev.layout6',
                disabledClass: 'house-swiper-disabled'
            };
            if (isMobile) {
                return fixSwiperOptions({
                    slidesPerView: 1.2,
                    ssrSlidesPerView: 2,
                    spaceBetween: 10,
                    loop: false,
                    speed: 1000,
                    initialSlide: 0,
                    navigation
                });
            } else {
                return fixSwiperOptions({
                    slidesPerView: 'auto',
                    ssrSlidesPerView: 4,
                    loop: false,
                    speed: 1000,
                    initialSlide: 0,
                    navigation
                });
            }
        },
        len() {
            // Less than 4 listings, number of default images
            let length = this.result.listings.length;
            // if (window.innerWidth > 1000) {
            return 4 - length;
            // } else {
            //     return 3 - length;
            // }
        },
        showPlaceholder() {
            if (this.isMobile) {
                return; 
            }
            let length = this.result.listings.length;
            // if (window.innerWidth > 1000) {
            return length < 4;
            // } else {
            //     return length < 3;
            // }
        }
    },
    components: {
        house,
        Swiper,
        Slide: SwiperSlide
    },
    mixins: [list],
    data() {
        return {
            picSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/md-house/layout6.png',
            // fixGrid: util.throttle(function(swiper) {
            //     // 修正抽搐动画，400=卡片宽度350+边距50
            //     // 只滑动slide的宽度 350, 不包含 spaceBetween 50
            //     let step = 390.5;
            //     swiper.slidesSizesGrid = swiper.slidesSizesGrid.map(e => step)
            //     swiper.slidesGrid = swiper.slidesGrid.map((e, index) => step * index)
            //     swiper.snapGrid = swiper.snapGrid.map((item, index) => step * index)
            // }, 100)
        };
    },
    // methods: {
    //     resetGrid(swiper) {
    //         this.fixGrid(swiper)
    //     }
    // }
};
</script>
